// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.drop-between-zone {\n  height: 4px;\n  width: 100%;\n  z-index: 1;\n}\n.drop-between-zone.active {\n  position: static;\n  top: 0;\n  border: 1px dashed #D2D2D2;\n  height: 24px;\n}\n", ""]);
// Exports
module.exports = exports;
